import { getPayments } from '../utils/apiService';

export const FETCH_PAYMENTS = 'dashboard/FETCH_PAYMENTS';
export const FETCH_PAYMENTS_PENDING = 'dashboard/FETCH_PAYMENTS_PENDING';
export const FETCH_PAYMENTS_REJECTED = 'dashboard/FETCH_PAYMENTS_REJECTED';
export const FETCH_PAYMENTS_FULFILLED = 'dashboard/FETCH_PAYMENTS_FULFILLED';

export const fetchPayments = (filter) => {
    return {
        type: FETCH_PAYMENTS,
        payload: getPayments(filter)
    }
}


// WEBPACK FOOTER //
// ./src/actions/payments.js